import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = {
  key: 1,
  class: "profile-content"
}
const _hoisted_3 = { class: "profile-header" }
const _hoisted_4 = { class: "user-basic-info" }
const _hoisted_5 = { class: "username" }
const _hoisted_6 = { class: "user-signature" }
const _hoisted_7 = { class: "profile-actions-header" }
const _hoisted_8 = { class: "profile-details" }
const _hoisted_9 = { class: "detail-section" }
const _hoisted_10 = { class: "detail-item" }
const _hoisted_11 = { class: "detail-item" }
const _hoisted_12 = { class: "detail-item" }
const _hoisted_13 = { class: "detail-item" }
const _hoisted_14 = { class: "detail-section" }
const _hoisted_15 = { class: "stats-grid" }
const _hoisted_16 = { class: "stat-item" }
const _hoisted_17 = { class: "stat-number" }
const _hoisted_18 = { class: "stat-item" }
const _hoisted_19 = { class: "stat-number" }
const _hoisted_20 = { class: "stat-item" }
const _hoisted_21 = { class: "stat-number" }
const _hoisted_22 = { class: "stat-item" }
const _hoisted_23 = { class: "stat-number" }
const _hoisted_24 = { class: "detail-section" }
const _hoisted_25 = { class: "detail-item" }
const _hoisted_26 = { class: "detail-item" }
const _hoisted_27 = {
  key: 2,
  class: "error"
}

import { ref, computed, watch } from 'vue';
import { ElDialog, ElAvatar, ElButton, ElMessage } from 'element-plus';
import { getUserById } from '@/user/api/userApi';  // 恢复使用getUserById
import { useStore } from 'vuex';
import { formatDate } from '@/utils/date';
import ReportModal from '../report/ReportModal.vue';

// --- API响应接口定义 ---
interface OtherUserProfile {
  id: number;
  username: string;
  name: string;
  avatar: string;
  email?: string;
  phone?: string;
  signature?: string;
  status: number;
  roleName: string;
  createTime: string;
  likeCount: number;
  postCount: number;
  followerCount: number;
  followeeCount: number;
}

interface ApiResponse {
  code: number;
  msg: string | null;
  data: OtherUserProfile;
}

interface Props {
  modelValue: boolean;
  userId: number;
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void;
  (e: 'close'): void;
  (e: 'report-user', payload: { targetType: number, targetId: number }): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OtherUserProfileModal',
  props: {
    modelValue: { type: Boolean },
    userId: {}
  },
  emits: ["update:modelValue", "close", "report-user"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const store = useStore();

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const userProfile = ref<OtherUserProfile | null>(null);
const loading = ref(false);
const statusText = ref('');
const statusClass = ref('');
const reportModalRef = ref(); // 添加举报模态框引用

// 获取当前登录用户信息
const currentUser = computed(() => {
  return store.state.userInfo || { id: null };
});

// 更新状态相关信息
const updateStatusInfo = (status: number) => {
  switch (status) {
    case 0:
      statusText.value = '封禁';
      statusClass.value = 'status-banned';
      break;
    case 1:
      statusText.value = '正常';
      statusClass.value = 'status-normal';
      break;
    case 2:
      statusText.value = '禁言';
      statusClass.value = 'status-muted';
      break;
    default:
      statusText.value = '未知';
      statusClass.value = 'status-unknown';
  }
};

const loadUserProfile = async () => {
  if (!props.userId) return;

  try {
    loading.value = true;
    
    // 调用API获取用户资料
    const response = await getUserById(props.userId);  // 改回调用getUserById
    
    console.log('API Response:', response); // 添加调试日志
    
    // 检查响应结构并提取数据
    let userData = null;
    
    // 情况1: 直接返回用户数据
    if (response.id) {
      userData = response;
    } 
    // 情况2: 包含标准响应格式 { code: 1, msg: null, data: {...} }
    else if (response.data && response.data.code === 1 && response.data.data) {
      userData = response.data.data;
    }
    // 情况3: 兼容其他可能的格式
    else if (response.data && typeof response.data === 'object' && response.data.id) {
      userData = response.data;
    }
    
    if (userData) {
      userProfile.value = userData;
      // 更新状态信息
      updateStatusInfo(userData.status);
    } else {
      console.error('API返回的数据格式不正确:', response);
      throw new Error('获取用户资料失败：数据格式不正确');
    }
  } catch (error: any) {
    console.error('获取用户资料失败:', error);
    userProfile.value = null;
  } finally {
    loading.value = false;
  }
};

// 关闭对话框
const handleClose = () => {
  emit('close');
};

// 举报用户
const openReportDialog = () => {
  if (!userProfile.value) return;
  
  // 检查是否为自己，如果是则不允许举报
  if (currentUser.value.id === userProfile.value.id) {
    ElMessage.warning('不能举报自己');
    return;
  }
  
  // 通过emit向父组件传递举报事件
  emit('report-user', {
    targetType: 3, // 3 表示用户
    targetId: userProfile.value.id
  });
};

// 监听弹窗显示状态变化
watch([dialogVisible, () => props.userId], ([newDialogVisible, newUserId], [oldDialogVisible, oldUserId]) => {
  // 当弹窗变为可见或userId发生变化时加载用户资料
  if (newDialogVisible && (newUserId !== oldUserId || !userProfile.value || userProfile.value.id !== newUserId)) {
    loadUserProfile();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    title: "用户信息",
    width: "600px",
    "close-on-click-modal": false,
    "before-close": handleClose,
    class: "warm-theme-dialog"
  }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "加载中..."))
        : (userProfile.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(ElAvatar), {
                  size: 100,
                  src: userProfile.value.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                  class: "profile-avatar"
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(userProfile.value.name || userProfile.value.username || '未知用户'), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(userProfile.value.signature || '暂无签名'), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(ElButton), {
                    type: "danger",
                    size: "small",
                    onClick: openReportDialog,
                    disabled: currentUser.value.id === userProfile.value.id
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode(" 举报用户 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "section-title" }, "账户信息", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[2] || (_cache[2] = _createElementVNode("label", null, "用户账号:", -1)),
                    _createElementVNode("span", null, _toDisplayString(userProfile.value.username || '未设置'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", null, "用户邮箱:", -1)),
                    _createElementVNode("span", null, _toDisplayString(userProfile.value.email || '未填写'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", null, "联系电话:", -1)),
                    _createElementVNode("span", null, _toDisplayString(userProfile.value.phone || '未填写'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", null, "注册时间:", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(formatDate)(userProfile.value.createTime)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "section-title" }, "统计信息", -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(userProfile.value.followeeCount || 0), 1),
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "stat-label" }, "关注数", -1))
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(userProfile.value.followerCount || 0), 1),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "stat-label" }, "粉丝数", -1))
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(userProfile.value.postCount || 0), 1),
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "stat-label" }, "作品数", -1))
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(userProfile.value.likeCount || 0), 1),
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "stat-label" }, "获赞数", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "section-title" }, "账户状态", -1)),
                  _createElementVNode("div", _hoisted_25, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", null, "用户角色:", -1)),
                    _createElementVNode("span", null, _toDisplayString(userProfile.value.roleName || '普通用户'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", null, "账户状态:", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(statusClass.value)
                    }, _toDisplayString(statusText.value), 3)
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_27, "无法加载用户信息"))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})